import { render, staticRenderFns } from "./FormVehiclePart.vue?vue&type=template&id=9b19c0e2"
import script from "./FormVehiclePart.vue?vue&type=script&lang=js"
export * from "./FormVehiclePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormVehiclePart.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b19c0e2')) {
      api.createRecord('9b19c0e2', component.options)
    } else {
      api.reload('9b19c0e2', component.options)
    }
    module.hot.accept("./FormVehiclePart.vue?vue&type=template&id=9b19c0e2", function () {
      api.rerender('9b19c0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/components/FormVehiclePart.vue"
export default component.exports